import { useEffect } from "react";
import { createBrowserRouter, RouteObject, useNavigate } from "react-router";
import { WebsiteRoutes } from "../NavigationData/NavigationData";
import AnimatedOutlet from "./AnimatedOutlet";

export default function RoutingComponent() {
  return <AnimatedOutlet />;
}

function RedirectToHome() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/");
  }, []);
  return <></>;
}

export const Router = createBrowserRouter([
  {
    path: "/",
    element: <RoutingComponent />,
    children: [WebsiteRoutes as RouteObject],
    ErrorBoundary: RedirectToHome,
  },
]);
